<ng-container [ngTemplateOutlet]="menuProjectedContent"></ng-container>


